import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import { Link } from "react-router-dom";
import {
  ArrowLeft,
  Trash2,
  Edit,
  Save,
  X,
  CreditCard,
  CheckCircle,
  AlertCircle,
  Search,
  Users,
  Filter,
  ArrowUpDown,
  RefreshCw,
  Layers,
} from "lucide-react";

export default function DaftarSiswa() {
  const [siswaList, setSiswaList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "success",
  });

  // --- STATE FILTER & SORT ---
  const [filterSearch, setFilterSearch] = useState("");
  const [filterKelas, setFilterKelas] = useState("");
  const [filterKelompok, setFilterKelompok] = useState(""); // <--- STATE BARU
  const [filterStatus, setFilterStatus] = useState("Aktif");
  const [sortBy, setSortBy] = useState("nama_asc");

  // Opsi Kelas
  const opsiKelas = [
    "TK",
    "1 SD",
    "2 SD",
    "3 SD",
    "4 SD",
    "5 SD",
    "6 SD",
    "7 SMP",
    "8 SMP",
    "9 SMP",
    "10 SMA",
    "11 SMA",
    "12 SMA",
    "Umum",
  ];

  // Form State
  const [formData, setFormData] = useState({
    nama_lengkap: "",
    kelas: "",
    nis: "",
    kelompok: "",
    status: "Aktif",
  });
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    fetchSiswa();
  }, []);

  const showToast = (message, type = "success") => {
    setToast({ show: true, message, type });
    setTimeout(() => setToast((prev) => ({ ...prev, show: false })), 3000);
  };

  async function fetchSiswa() {
    setLoading(true);
    const { data, error } = await supabase
      .from("siswa")
      .select("*")
      .order("nama_lengkap", { ascending: true });
    if (error) console.error("Gagal ambil data:", error);
    setSiswaList(data || []);
    setLoading(false);
  }

  // --- AMBIL LIST UNIK KELOMPOK DARI DATA ---
  // Mengambil semua nama kelompok yang ada, membuang duplikat, dan mengurutkan
  const opsiKelompok = [
    ...new Set(
      siswaList.map((s) => s.kelompok).filter((k) => k && k.trim() !== "")
    ),
  ].sort();

  // --- LOGIKA FILTER & SORTING ---
  const getFilteredSiswa = () => {
    let result = [...siswaList];

    // 1. Filter Search
    if (filterSearch) {
      result = result.filter(
        (s) =>
          s.nama_lengkap.toLowerCase().includes(filterSearch.toLowerCase()) ||
          (s.nis && s.nis.includes(filterSearch))
      );
    }
    // 2. Filter Kelas
    if (filterKelas) {
      result = result.filter((s) => s.kelas === filterKelas);
    }
    // 3. Filter Kelompok (BARU)
    if (filterKelompok) {
      result = result.filter((s) => s.kelompok === filterKelompok);
    }
    // 4. Filter Status
    if (filterStatus !== "Semua") {
      result = result.filter((s) => s.status === filterStatus);
    }

    // 5. Sorting
    result.sort((a, b) => {
      if (sortBy === "nama_asc")
        return a.nama_lengkap.localeCompare(b.nama_lengkap);
      if (sortBy === "nama_desc")
        return b.nama_lengkap.localeCompare(a.nama_lengkap);
      if (sortBy === "kelas_asc") return a.kelas.localeCompare(b.kelas);
      return 0;
    });

    return result;
  };

  const filteredData = getFilteredSiswa();

  // --- CRUD LOGIC ---
  async function handleSubmit(e) {
    e.preventDefault();
    if (!formData.nama_lengkap || !formData.kelas)
      return showToast("Nama dan Kelas wajib!", "error");

    try {
      const payload = {
        nama_lengkap: formData.nama_lengkap,
        kelas: formData.kelas,
        nis: formData.nis.trim() === "" ? null : formData.nis,
        kelompok: formData.kelompok.trim() === "" ? null : formData.kelompok,
        status: formData.status,
      };

      if (isEditing) {
        await supabase.from("siswa").update(payload).eq("id", editId);
      } else {
        await supabase.from("siswa").insert([payload]);
      }

      showToast(
        isEditing ? "Data diperbarui!" : "Siswa ditambahkan!",
        "success"
      );
      resetForm();
      fetchSiswa();
    } catch (error) {
      showToast(`Gagal: ${error.message}`, "error");
    }
  }

  async function handleDelete(id) {
    if (!window.confirm("Yakin hapus permanen?")) return;
    try {
      setLoading(true);
      await supabase.from("tagihan").delete().eq("siswa_id", id);
      await supabase.from("nilai").delete().eq("siswa_id", id);
      try {
        await supabase.from("relasi_siswa_tutor").delete().eq("siswa_id", id);
      } catch (e) {}
      await supabase.from("siswa").delete().eq("id", id);
      showToast("Siswa dihapus.", "success");
      fetchSiswa();
    } catch (error) {
      showToast("Gagal hapus", "error");
    } finally {
      setLoading(false);
    }
  }

  function handleEditClick(siswa) {
    setIsEditing(true);
    setEditId(siswa.id);
    setShowForm(true);
    setFormData({
      nama_lengkap: siswa.nama_lengkap,
      kelas: siswa.kelas,
      nis: siswa.nis || "",
      kelompok: siswa.kelompok || "",
      status: siswa.status || "Aktif",
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  function resetForm() {
    setIsEditing(false);
    setEditId(null);
    setFormData({
      nama_lengkap: "",
      kelas: "",
      nis: "",
      kelompok: "",
      status: "Aktif",
    });
  }

  // --- STYLES ---
  const styles = {
    container: {
      padding: "20px",
      maxWidth: "1100px",
      margin: "0 auto",
      fontFamily: "'Inter', sans-serif",
    },
    filterBar: {
      background: "white",
      padding: "15px",
      borderRadius: "12px",
      border: "1px solid #E2E8F0",
      marginBottom: "20px",
      display: "flex",
      gap: "10px",
      flexWrap: "wrap",
      alignItems: "center",
    },
    inputSearch: {
      flex: 1,
      minWidth: "200px",
      padding: "10px 10px 10px 35px",
      borderRadius: "8px",
      border: "1px solid #CBD5E1",
      fontSize: "14px",
      outline: "none",
    },
    selectFilter: {
      padding: "10px",
      borderRadius: "8px",
      border: "1px solid #CBD5E1",
      fontSize: "13px",
      background: "white",
      cursor: "pointer",
      outline: "none",
    },
    btnAdd: {
      background: "#2563EB",
      color: "white",
      padding: "10px 15px",
      borderRadius: "8px",
      border: "none",
      cursor: "pointer",
      fontWeight: "600",
      display: "flex",
      alignItems: "center",
      gap: 5,
    },

    // Status Badge
    statusBadge: (status) => ({
      padding: "4px 10px",
      borderRadius: "20px",
      fontSize: "11px",
      fontWeight: "700",
      textTransform: "uppercase",
      background: status === "Aktif" ? "#DCFCE7" : "#F1F5F9",
      color: status === "Aktif" ? "#166534" : "#64748B",
      border: status === "Aktif" ? "1px solid #bbf7d0" : "1px solid #e2e8f0",
    }),

    // Form Style
    formCard: {
      background: "#F8FAFC",
      padding: "25px",
      borderRadius: "16px",
      border: "2px dashed #E2E8F0",
      marginBottom: "30px",
    },
    inputForm: {
      width: "100%",
      padding: "12px",
      borderRadius: "8px",
      border: "1px solid #CBD5E1",
      marginBottom: "15px",
      boxSizing: "border-box",
      background: "white",
    },
  };

  return (
    <div style={styles.container}>
      {toast.show && (
        <div
          style={{
            position: "fixed",
            top: 20,
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 9999,
            background: toast.type === "success" ? "#065F46" : "#991B1B",
            color: "white",
            padding: "10px 20px",
            borderRadius: 8,
            fontSize: 14,
            fontWeight: "bold",
            boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1)",
          }}
        >
          {toast.message}
        </div>
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 20,
        }}
      >
        <Link
          to="/"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            textDecoration: "none",
            color: "#64748B",
            fontWeight: "500",
          }}
        >
          <ArrowLeft size={18} /> Kembali
        </Link>
        <button onClick={() => setShowForm(!showForm)} style={styles.btnAdd}>
          {showForm ? <X size={18} /> : <Edit size={18} />}{" "}
          {showForm ? "Tutup Form" : "Tambah / Edit Siswa"}
        </button>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          marginBottom: 20,
        }}
      >
        <div style={{ background: "#EFF6FF", padding: 10, borderRadius: 12 }}>
          <Users size={28} color="#2563EB" />
        </div>
        <div>
          <h2 style={{ margin: 0, color: "#1E293B", fontSize: 22 }}>
            Data Siswa
          </h2>
          <p style={{ margin: 0, color: "#64748B", fontSize: 14 }}>
            Total: {filteredData.length} siswa ditampilkan
          </p>
        </div>
      </div>

      {/* FORM INPUT */}
      {showForm && (
        <div style={styles.formCard}>
          <h3 style={{ marginTop: 0, marginBottom: 15, color: "#334155" }}>
            {isEditing ? "Edit Siswa" : "Tambah Siswa Baru"}
          </h3>
          <form onSubmit={handleSubmit}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                gap: 20,
              }}
            >
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: 5,
                    fontSize: 13,
                    fontWeight: 600,
                  }}
                >
                  Nama Lengkap
                </label>
                <input
                  style={styles.inputForm}
                  placeholder="Budi Santoso"
                  value={formData.nama_lengkap}
                  onChange={(e) =>
                    setFormData({ ...formData, nama_lengkap: e.target.value })
                  }
                />
              </div>
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: 5,
                    fontSize: 13,
                    fontWeight: 600,
                  }}
                >
                  Kelas
                </label>
                <select
                  style={styles.inputForm}
                  value={formData.kelas}
                  onChange={(e) =>
                    setFormData({ ...formData, kelas: e.target.value })
                  }
                >
                  <option value="">-- Pilih --</option>
                  {opsiKelas.map((k) => (
                    <option key={k} value={k}>
                      {k}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: 5,
                    fontSize: 13,
                    fontWeight: 600,
                  }}
                >
                  Status
                </label>
                <select
                  style={styles.inputForm}
                  value={formData.status}
                  onChange={(e) =>
                    setFormData({ ...formData, status: e.target.value })
                  }
                >
                  <option value="Aktif">Aktif</option>
                  <option value="Tidak Aktif">Tidak Aktif</option>
                </select>
              </div>
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: 5,
                    fontSize: 13,
                    fontWeight: 600,
                  }}
                >
                  Kelompok (Opsional)
                </label>
                <input
                  style={styles.inputForm}
                  placeholder="Kelompok A"
                  value={formData.kelompok}
                  onChange={(e) =>
                    setFormData({ ...formData, kelompok: e.target.value })
                  }
                />
              </div>
            </div>
            <button
              type="submit"
              style={{
                ...styles.btnAdd,
                width: "100%",
                justifyContent: "center",
                marginTop: 10,
              }}
            >
              <Save size={18} /> Simpan Data
            </button>
          </form>
        </div>
      )}

      {/* --- FILTER BAR --- */}
      <div style={styles.filterBar}>
        <div style={{ position: "relative", flex: 1 }}>
          <Search
            size={16}
            color="#94A3B8"
            style={{ position: "absolute", left: 10, top: 12 }}
          />
          <input
            style={styles.inputSearch}
            placeholder="Cari Nama atau NIS..."
            value={filterSearch}
            onChange={(e) => setFilterSearch(e.target.value)}
          />
        </div>

        {/* Filter Kelas */}
        <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
          <Filter size={16} color="#64748B" />
          <select
            style={styles.selectFilter}
            value={filterKelas}
            onChange={(e) => setFilterKelas(e.target.value)}
          >
            <option value="">Semua Kelas</option>
            {opsiKelas.map((k) => (
              <option key={k} value={k}>
                {k}
              </option>
            ))}
          </select>
        </div>

        {/* Filter Kelompok (BARU) */}
        <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
          <Layers size={16} color="#64748B" />
          <select
            style={styles.selectFilter}
            value={filterKelompok}
            onChange={(e) => setFilterKelompok(e.target.value)}
          >
            <option value="">Semua Kelompok</option>
            {opsiKelompok.map((k) => (
              <option key={k} value={k}>
                {k}
              </option>
            ))}
          </select>
        </div>

        <select
          style={styles.selectFilter}
          value={filterStatus}
          onChange={(e) => setFilterStatus(e.target.value)}
        >
          <option value="Aktif">Hanya Aktif</option>
          <option value="Tidak Aktif">Tidak Aktif</option>
          <option value="Semua">Semua Status</option>
        </select>

        <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
          <ArrowUpDown size={16} color="#64748B" />
          <select
            style={styles.selectFilter}
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
          >
            <option value="nama_asc">Nama (A-Z)</option>
            <option value="nama_desc">Nama (Z-A)</option>
            <option value="kelas_asc">Kelas (Urut)</option>
          </select>
        </div>

        {/* Tombol Reset */}
        {(filterSearch ||
          filterKelas ||
          filterKelompok ||
          filterStatus !== "Aktif") && (
          <button
            onClick={() => {
              setFilterSearch("");
              setFilterKelas("");
              setFilterKelompok("");
              setFilterStatus("Aktif");
              setSortBy("nama_asc");
            }}
            style={{
              background: "#F1F5F9",
              border: "none",
              padding: 8,
              borderRadius: 8,
              cursor: "pointer",
              color: "#64748B",
            }}
            title="Reset Filter"
          >
            <RefreshCw size={16} />
          </button>
        )}
      </div>

      {/* LIST DATA */}
      {loading ? (
        <p style={{ textAlign: "center" }}>Memuat data...</p>
      ) : (
        <div
          style={{
            background: "white",
            borderRadius: "12px",
            border: "1px solid #E2E8F0",
            overflowX: "auto",
            boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              minWidth: "800px",
            }}
          >
            <thead>
              <tr
                style={{
                  background: "#F8FAFC",
                  borderBottom: "1px solid #E2E8F0",
                }}
              >
                <th
                  style={{
                    padding: "15px",
                    textAlign: "left",
                    fontSize: "13px",
                    color: "#475569",
                  }}
                >
                  NAMA SISWA
                </th>
                <th
                  style={{
                    padding: "15px",
                    textAlign: "left",
                    fontSize: "13px",
                    color: "#475569",
                  }}
                >
                  KELAS
                </th>
                <th
                  style={{
                    padding: "15px",
                    textAlign: "left",
                    fontSize: "13px",
                    color: "#475569",
                  }}
                >
                  KELOMPOK
                </th>
                <th
                  style={{
                    padding: "15px",
                    textAlign: "center",
                    fontSize: "13px",
                    color: "#475569",
                  }}
                >
                  STATUS
                </th>
                <th
                  style={{
                    padding: "15px",
                    textAlign: "right",
                    fontSize: "13px",
                    color: "#475569",
                  }}
                >
                  AKSI
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((siswa, idx) => (
                <tr
                  key={siswa.id}
                  style={{
                    borderBottom: "1px solid #F1F5F9",
                    opacity: siswa.status === "Tidak Aktif" ? 0.6 : 1,
                  }}
                >
                  {/* KOLOM NAMA */}
                  <td style={{ padding: "15px" }}>
                    <div style={{ fontWeight: "600", color: "#1E293B" }}>
                      {siswa.nama_lengkap}
                    </div>
                    {siswa.nis && (
                      <div style={{ fontSize: 12, color: "#64748B" }}>
                        NIS: {siswa.nis}
                      </div>
                    )}
                  </td>

                  {/* KOLOM KELAS */}
                  <td style={{ padding: "15px" }}>
                    <span
                      style={{
                        background: "#F1F5F9",
                        padding: "4px 10px",
                        borderRadius: "20px",
                        fontSize: "12px",
                        fontWeight: "600",
                        color: "#475569",
                      }}
                    >
                      {siswa.kelas}
                    </span>
                  </td>

                  {/* KOLOM KELOMPOK */}
                  <td style={{ padding: "15px" }}>
                    {siswa.kelompok ? (
                      <span
                        style={{
                          background: "#E0F2FE",
                          padding: "4px 10px",
                          borderRadius: "20px",
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#0284C7",
                          border: "1px solid #BAE6FD",
                        }}
                      >
                        {siswa.kelompok}
                      </span>
                    ) : (
                      <span style={{ color: "#CBD5E1", fontSize: 14 }}>-</span>
                    )}
                  </td>

                  {/* KOLOM STATUS */}
                  <td style={{ padding: "15px", textAlign: "center" }}>
                    <span style={styles.statusBadge(siswa.status)}>
                      {siswa.status || "Aktif"}
                    </span>
                  </td>

                  {/* KOLOM AKSI */}
                  <td style={{ padding: "15px", textAlign: "right" }}>
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Link to={`/siswa/${siswa.id}`}>
                        <button
                          style={{
                            background: "#ECFDF5",
                            color: "#059669",
                            border: "1px solid #D1FAE5",
                            padding: "6px",
                            borderRadius: "6px",
                            cursor: "pointer",
                          }}
                          title="Tagihan SPP"
                        >
                          <CreditCard size={16} />
                        </button>
                      </Link>
                      <button
                        onClick={() => handleEditClick(siswa)}
                        style={{
                          background: "#FFF7ED",
                          color: "#D97706",
                          border: "1px solid #FFEDD5",
                          padding: "6px",
                          borderRadius: "6px",
                          cursor: "pointer",
                        }}
                      >
                        <Edit size={16} />
                      </button>
                      <button
                        onClick={() => handleDelete(siswa.id)}
                        style={{
                          background: "#FEF2F2",
                          color: "#EF4444",
                          border: "1px solid #FEE2E2",
                          padding: "6px",
                          borderRadius: "6px",
                          cursor: "pointer",
                        }}
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {filteredData.length === 0 && (
            <div style={{ padding: 40, textAlign: "center", color: "#94A3B8" }}>
              Tidak ada data siswa yang cocok dengan filter.
            </div>
          )}
        </div>
      )}
    </div>
  );
}
